var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "basic-container",
        { ref: "eltable" },
        [
          !_vm.showAdd
            ? _c(
                "div",
                { staticClass: "page-container activity-manage-page" },
                [
                  _c(
                    "div",
                    { staticClass: "tabs" },
                    [
                      _c(
                        "el-tabs",
                        {
                          attrs: { value: _vm.activiedTab, type: "card" },
                          on: { "tab-click": _vm.handleTabClick },
                        },
                        [
                          _c("el-tab-pane", {
                            attrs: { name: "1", label: "线上数据" },
                          }),
                          _c("el-tab-pane", {
                            attrs: { name: "0", label: "本地数据" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      staticClass: "table table-wrap",
                      attrs: { "element-loading-text": "加载中" },
                    },
                    [
                      _vm.isLocal
                        ? _c(
                            "div",
                            { staticClass: "local-table" },
                            [
                              _c(
                                "avue-crud",
                                {
                                  ref: "crud",
                                  attrs: {
                                    option: _vm.avueOption,
                                    "table-loading": _vm.loading,
                                    data: _vm.tableData,
                                    page: _vm.page,
                                  },
                                  on: {
                                    "selection-change": _vm.handleSelect,
                                    "update:page": function ($event) {
                                      _vm.page = $event
                                    },
                                    "on-load": _vm.getList,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "appName",
                                        fn: function (scope) {
                                          return [
                                            scope.row.appName !== ""
                                              ? [
                                                  scope.row.appNames.length < 5
                                                    ? _vm._l(
                                                        scope.row.appNames,
                                                        function (item, index) {
                                                          return _c(
                                                            "el-tag",
                                                            {
                                                              key: index,
                                                              attrs: {
                                                                size: "mini",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(item)
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    : [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "10px",
                                                            },
                                                            attrs: {
                                                              size: "mini",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .appNames[0]
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-popover",
                                                          {
                                                            attrs: {
                                                              placement:
                                                                "right",
                                                              width: "400",
                                                              trigger: "click",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              _vm._l(
                                                                scope.row
                                                                  .appNames,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "el-tag",
                                                                    {
                                                                      key: index,
                                                                      attrs: {
                                                                        size: "mini",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                            _c(
                                                              "el-tag",
                                                              {
                                                                attrs: {
                                                                  slot: "reference",
                                                                  size: "mini",
                                                                },
                                                                slot: "reference",
                                                              },
                                                              [_vm._v(".....")]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                ]
                                              : [
                                                  _c(
                                                    "el-tag",
                                                    { attrs: { size: "mini" } },
                                                    [_vm._v("全部渠道")]
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                      {
                                        key: "productName",
                                        fn: function (scope) {
                                          return [
                                            scope.row.productName
                                              ? _vm._l(
                                                  scope.row.productName,
                                                  function (item, index) {
                                                    return _c(
                                                      "el-tag",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          size: "mini",
                                                          type: "warning",
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(item))]
                                                    )
                                                  }
                                                )
                                              : [_c("span", [_vm._v("-")])],
                                          ]
                                        },
                                      },
                                      {
                                        key: "leftAmount",
                                        fn: function (scope) {
                                          return [
                                            scope.row.giftMode == 1
                                              ? [
                                                  scope.row.leftAmount > 0
                                                    ? [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              type: "text",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .leftAmount
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ]
                                              : [_vm._v(" - ")],
                                          ]
                                        },
                                      },
                                      {
                                        key: "startDate",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.startDate) +
                                                  " 至 " +
                                                  _vm._s(scope.row.endDate)
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "maxAmount",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.maxAmount > 0
                                                    ? scope.row.maxAmount
                                                    : "无限制"
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "menu",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "auth",
                                                    rawName: "v-auth",
                                                    value: "ACTIVITY_VIEW_LOG",
                                                    expression:
                                                      "'ACTIVITY_VIEW_LOG'",
                                                  },
                                                ],
                                                attrs: {
                                                  size: "mini",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleCheckLogs(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("查看日志")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "auth",
                                                    rawName: "v-auth",
                                                    value: "ACTIVITY_EDIT",
                                                    expression:
                                                      "'ACTIVITY_EDIT'",
                                                  },
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.isLocal &&
                                                      scope.row.reviewStatus !=
                                                        1,
                                                    expression:
                                                      "isLocal && scope.row.reviewStatus != 1",
                                                  },
                                                ],
                                                attrs: {
                                                  size: "mini",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEdit(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("编辑")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "auth",
                                                    rawName: "v-auth",
                                                    value: "ACTIVITY_ADD",
                                                    expression:
                                                      "'ACTIVITY_ADD'",
                                                  },
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.isLocal &&
                                                      scope.row.reviewStatus !=
                                                        1,
                                                    expression:
                                                      "isLocal && scope.row.reviewStatus != 1",
                                                  },
                                                ],
                                                attrs: {
                                                  size: "mini",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleCopy(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("复制")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "auth",
                                                    rawName: "v-auth",
                                                    value: "ACTIVITY_APPROVE",
                                                    expression:
                                                      "'ACTIVITY_APPROVE'",
                                                  },
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      scope.row.reviewStatus ==
                                                      1,
                                                    expression:
                                                      "scope.row.reviewStatus == 1",
                                                  },
                                                ],
                                                attrs: {
                                                  size: "mini",
                                                  type: "text",
                                                  loading: _vm.approveLoading,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleApprove(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("审核")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "auth",
                                                    rawName: "v-auth",
                                                    value:
                                                      "ACTIVITY_REVOCATION",
                                                    expression:
                                                      "'ACTIVITY_REVOCATION'",
                                                  },
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      scope.row.reviewStatus ==
                                                      1,
                                                    expression:
                                                      "scope.row.reviewStatus == 1",
                                                  },
                                                ],
                                                attrs: {
                                                  size: "mini",
                                                  type: "text",
                                                  loading: _vm.approveLoading,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleRevocation(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("撤销审核")]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "auth",
                                                    rawName: "v-auth",
                                                    value:
                                                      "ACTIVITY_APPROVE_SUBMIT",
                                                    expression:
                                                      "'ACTIVITY_APPROVE_SUBMIT'",
                                                  },
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      scope.row.reviewStatus ==
                                                      0,
                                                    expression:
                                                      "scope.row.reviewStatus == 0",
                                                  },
                                                ],
                                                attrs: {
                                                  size: "mini",
                                                  type: "text",
                                                  loading: _vm.approveLoading,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleApproveRequest(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("提交审核")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3631897822
                                  ),
                                },
                                [
                                  _c("template", { slot: "menuLeft" }, [
                                    _c(
                                      "div",
                                      { staticClass: "query-form-wrap" },
                                      [
                                        _c(
                                          "el-form",
                                          {
                                            attrs: {
                                              inline: true,
                                              model: _vm.form,
                                              size: _vm.formSize,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              [
                                                _c("DynamicOption", {
                                                  staticClass: "search-item",
                                                  attrs: {
                                                    placeholder: "渠道",
                                                    singleSelect: true,
                                                  },
                                                  model: {
                                                    value: _vm.form.appId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "appId",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.appId",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "状态",
                                                    },
                                                    model: {
                                                      value: _vm.form.status,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "status",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.status",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.activityStatus,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.dictKey,
                                                        attrs: {
                                                          label: item.dictValue,
                                                          value: item.dictKey,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "活动类型",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.promotionType,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "promotionType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.promotionType",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.promotionTypes,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.dictKey,
                                                        attrs: {
                                                          label: item.dictValue,
                                                          value: item.dictKey,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.isLocal,
                                                    expression: "isLocal",
                                                  },
                                                ],
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "审核状态",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.reviewStatus,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "reviewStatus",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.reviewStatus",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.approveStatus,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.dictKey,
                                                        attrs: {
                                                          label: item.dictValue,
                                                          value: item.dictKey,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "赠品类型",
                                                    },
                                                    model: {
                                                      value: _vm.form.giftId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "giftId",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.giftId",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.giftTypeOptions,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label: item.giftName,
                                                          value: item.id,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "短信提醒",
                                                    },
                                                    model: {
                                                      value: _vm.form.isSms,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "isSms",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.isSms",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.SMSStatus,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.dictKey,
                                                        attrs: {
                                                          label: item.dictValue,
                                                          value: item.dictKey,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder:
                                                      "活动名称/活动ID",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.promotionName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "promotionName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.promotionName",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "auth",
                                                        rawName: "v-auth",
                                                        value:
                                                          "ACTIVITY_SEARCH",
                                                        expression:
                                                          "'ACTIVITY_SEARCH'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      loading: _vm.listLoading,
                                                      icon: "el-icon-search",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: _vm.handleSearch,
                                                    },
                                                  },
                                                  [_vm._v("搜索")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "auth",
                                                        rawName: "v-auth",
                                                        value: "ACTIVITY_ADD",
                                                        expression:
                                                          "'ACTIVITY_ADD'",
                                                      },
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.isLocal,
                                                        expression: "isLocal",
                                                      },
                                                    ],
                                                    attrs: {
                                                      icon: "el-icon-plus",
                                                      plain: "",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: _vm.handleOpen,
                                                    },
                                                  },
                                                  [_vm._v("新增")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "auth",
                                                        rawName: "v-auth",
                                                        value:
                                                          "ACTIVITY_DELETE",
                                                        expression:
                                                          "'ACTIVITY_DELETE'",
                                                      },
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.isLocal,
                                                        expression: "isLocal",
                                                      },
                                                    ],
                                                    attrs: {
                                                      icon: "el-icon-delete",
                                                      loading: _vm.delLoading,
                                                      plain: "",
                                                      type: "danger",
                                                    },
                                                    on: {
                                                      click: _vm.handleDelete,
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "online-table" },
                            [
                              _c(
                                "avue-crud",
                                {
                                  ref: "crud2",
                                  attrs: {
                                    option: _vm.onLineOption,
                                    "table-loading": _vm.loading,
                                    data: _vm.tableData,
                                    page: _vm.page,
                                  },
                                  on: {
                                    "update:page": function ($event) {
                                      _vm.page = $event
                                    },
                                    "on-load": _vm.getList,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "appName",
                                        fn: function (scope) {
                                          return [
                                            scope.row.appName !== ""
                                              ? [
                                                  scope.row.appNames.length < 5
                                                    ? _vm._l(
                                                        scope.row.appNames,
                                                        function (item, index) {
                                                          return _c(
                                                            "el-tag",
                                                            {
                                                              key: index,
                                                              attrs: {
                                                                size: "mini",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(item)
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    : [
                                                        _c(
                                                          "el-tag",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "10px",
                                                            },
                                                            attrs: {
                                                              size: "mini",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .appNames[0]
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "el-popover",
                                                          {
                                                            attrs: {
                                                              placement:
                                                                "right",
                                                              width: "400",
                                                              trigger: "click",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              _vm._l(
                                                                scope.row
                                                                  .appNames,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "el-tag",
                                                                    {
                                                                      key: index,
                                                                      attrs: {
                                                                        size: "mini",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                            _c(
                                                              "el-tag",
                                                              {
                                                                attrs: {
                                                                  slot: "reference",
                                                                  size: "mini",
                                                                },
                                                                slot: "reference",
                                                              },
                                                              [_vm._v(".....")]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                ]
                                              : [
                                                  _c(
                                                    "el-tag",
                                                    { attrs: { size: "mini" } },
                                                    [_vm._v("全部渠道")]
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                      {
                                        key: "productName",
                                        fn: function (scope) {
                                          return [
                                            scope.row.productName
                                              ? _vm._l(
                                                  scope.row.productName,
                                                  function (item, index) {
                                                    return _c(
                                                      "el-tag",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          size: "mini",
                                                          type: "warning",
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(item))]
                                                    )
                                                  }
                                                )
                                              : [_c("span", [_vm._v("-")])],
                                          ]
                                        },
                                      },
                                      {
                                        key: "leftAmount",
                                        fn: function (scope) {
                                          return [
                                            scope.row.giftMode == 1
                                              ? [
                                                  scope.row.leftAmount > 0
                                                    ? [
                                                        _c(
                                                          "router-link",
                                                          {
                                                            attrs: {
                                                              to: {
                                                                path: "/runActivityManage/giftManage",
                                                                query: {
                                                                  id: scope.row
                                                                    .giftId,
                                                                  status: "1",
                                                                },
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-button",
                                                              {
                                                                staticStyle: {
                                                                  "text-decoration":
                                                                    "underline",
                                                                },
                                                                attrs: {
                                                                  type: "text",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    scope.row
                                                                      .leftAmount
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                ]
                                              : [_vm._v(" - ")],
                                          ]
                                        },
                                      },
                                      {
                                        key: "startDate",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(scope.row.startDate) +
                                                  " 至 " +
                                                  _vm._s(scope.row.endDate)
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "maxAmount",
                                        fn: function (scope) {
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.maxAmount > 0
                                                    ? scope.row.maxAmount
                                                    : "无限制"
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "menu",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleCheckSendInfo(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("查看发放信息")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3302640538
                                  ),
                                },
                                [
                                  _c("template", { slot: "menuLeft" }, [
                                    _c(
                                      "div",
                                      { staticClass: "query-form-wrap" },
                                      [
                                        _c(
                                          "el-form",
                                          {
                                            attrs: {
                                              inline: true,
                                              model: _vm.form,
                                              size: _vm.formSize,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-form-item",
                                              [
                                                _c("DynamicOption", {
                                                  staticClass: "search-item",
                                                  attrs: {
                                                    placeholder: "渠道",
                                                    singleSelect: true,
                                                  },
                                                  model: {
                                                    value: _vm.form.appId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "appId",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.appId",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "状态",
                                                    },
                                                    model: {
                                                      value: _vm.form.status,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "status",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.status",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.activityStatus,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.dictKey,
                                                        attrs: {
                                                          label: item.dictValue,
                                                          value: item.dictKey,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "活动类型",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.promotionType,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "promotionType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.promotionType",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.promotionTypes,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.dictKey,
                                                        attrs: {
                                                          label: item.dictValue,
                                                          value: item.dictKey,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.isLocal,
                                                    expression: "isLocal",
                                                  },
                                                ],
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "审核状态",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.reviewStatus,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "reviewStatus",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.reviewStatus",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.approveStatus,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.dictKey,
                                                        attrs: {
                                                          label: item.dictValue,
                                                          value: item.dictKey,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "赠品类型",
                                                    },
                                                    model: {
                                                      value: _vm.form.giftId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "giftId",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.giftId",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.giftTypeOptions,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        attrs: {
                                                          label: item.giftName,
                                                          value: item.id,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      clearable: "",
                                                      placeholder: "短信提醒",
                                                    },
                                                    model: {
                                                      value: _vm.form.isSms,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "isSms",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.isSms",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.SMSStatus,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.dictKey,
                                                        attrs: {
                                                          label: item.dictValue,
                                                          value: item.dictKey,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    clearable: "",
                                                    placeholder:
                                                      "活动名称/活动ID",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.promotionName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "promotionName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.promotionName",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-form-item",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "auth",
                                                        rawName: "v-auth",
                                                        value:
                                                          "ACTIVITY_SEARCH",
                                                        expression:
                                                          "'ACTIVITY_SEARCH'",
                                                      },
                                                    ],
                                                    attrs: {
                                                      loading: _vm.listLoading,
                                                      icon: "el-icon-search",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: _vm.handleSearch,
                                                    },
                                                  },
                                                  [_vm._v("搜索")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "auth",
                                                        rawName: "v-auth",
                                                        value: "ACTIVITY_ADD",
                                                        expression:
                                                          "'ACTIVITY_ADD'",
                                                      },
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.isLocal,
                                                        expression: "isLocal",
                                                      },
                                                    ],
                                                    attrs: {
                                                      icon: "el-icon-plus",
                                                      plain: "",
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: _vm.handleOpen,
                                                    },
                                                  },
                                                  [_vm._v("新增")]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "auth",
                                                        rawName: "v-auth",
                                                        value:
                                                          "ACTIVITY_DELETE",
                                                        expression:
                                                          "'ACTIVITY_DELETE'",
                                                      },
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: _vm.isLocal,
                                                        expression: "isLocal",
                                                      },
                                                    ],
                                                    attrs: {
                                                      icon: "el-icon-delete",
                                                      loading: _vm.delLoading,
                                                      plain: "",
                                                      type: "danger",
                                                    },
                                                    on: {
                                                      click: _vm.handleDelete,
                                                    },
                                                  },
                                                  [_vm._v("删除")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                    ]
                  ),
                ]
              )
            : _c("add-activity-form", {
                attrs: {
                  "is-edit": _vm.isEdit,
                  "is-copy": _vm.isCopy,
                  row: _vm.currentRow,
                },
                on: { reload: _vm.handleSearch, cancel: _vm.handleCancel },
              }),
          _c(
            "el-dialog",
            {
              attrs: {
                width: "600px",
                title: "审核",
                "custom-class": "approve-dialog__wrap",
                visible: _vm.showApprove,
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showApprove = $event
                },
                close: _vm.handleClose,
              },
            },
            [
              _c("div", { staticClass: "approve-popups-inner__body" }, [
                _c(
                  "div",
                  { staticClass: "approve-popups-from__wrap" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "approve",
                        attrs: {
                          size: _vm.formSize,
                          model: _vm.approveForm,
                          rules: _vm.formRules,
                          "label-width": "120px",
                        },
                      },
                      [
                        _c("el-form-item", { attrs: { label: "配置渠道" } }, [
                          _c("p", { staticClass: "activity-content channel" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.currentRow.appName === ""
                                    ? "全渠道"
                                    : _vm.currentRow.appName
                                ) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _c("el-form-item", { attrs: { label: "活动名称" } }, [
                          _c("p", { staticClass: "activity-content" }, [
                            _vm._v(_vm._s(_vm.currentRow.name)),
                          ]),
                        ]),
                        _c("el-form-item", { attrs: { label: "有效期" } }, [
                          _c("p", { staticClass: "activity-content" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.currentRow.startDate) +
                                " 至 " +
                                _vm._s(_vm.currentRow.endDate) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _c("el-form-item", { attrs: { label: "状态" } }, [
                          _c("p", { staticClass: "activity-content" }, [
                            _vm._v(_vm._s(_vm.formatStatus(_vm.currentRow))),
                          ]),
                        ]),
                        _c("el-form-item", { attrs: { label: "备注" } }, [
                          _c("p", { staticClass: "activity-content" }, [
                            _vm._v(_vm._s(_vm.currentRow.remark)),
                          ]),
                        ]),
                        _vm._l(_vm.currentRow.ruleList, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticStyle: { position: "relative" },
                            },
                            [
                              _vm.currentRow.promotionType == 4
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "80%",
                                        "padding-bottom": "30px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "会员商品：" } },
                                        [
                                          _c("el-cascader", {
                                            attrs: {
                                              disabled: "",
                                              placeholder: "会员商品",
                                              props: { multiple: true },
                                              options: _vm.memberGoods,
                                              size: "small",
                                              separator: "-",
                                            },
                                            on: {
                                              change: (val) => {
                                                _vm.$set(item, "productId", val)
                                              },
                                            },
                                            model: {
                                              value: item.productId,
                                              callback: function ($$v) {
                                                _vm.$set(item, "productId", $$v)
                                              },
                                              expression: "item.productId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "商品图片：" } },
                                        [
                                          _c("el-image", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src: item.goodsPic,
                                              fit: "scale-down",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "权益图片：" } },
                                        [
                                          _c("el-image", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src: item.rightsPic,
                                              fit: "scale-down",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "乐播图片：" } },
                                        [
                                          _c("el-image", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src: item.leboPic,
                                              fit: "scale-down",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "按钮图片：" } },
                                        [
                                          _c("el-image", {
                                            staticClass: "avatar",
                                            attrs: {
                                              src: item.buttonImageUrl,
                                              fit: "scale-down",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "活动说明：" } },
                                        [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                item.promotionDescribe
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.currentRow.promotionType == 5
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "80%",
                                        "padding-bottom": "30px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "活动规则" + (index + 1),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.ruleTypeLabel) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "50px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "用户类型" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.userTypeLabel)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          item.userType === "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "用户标签" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.userTagsLabel
                                                              ? item.userTagsLabel
                                                              : "-"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          item.userType === "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "用户数量" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.userAmountLabel
                                                              ? item.userAmountLabel
                                                              : "-"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          item.isAllPlatform == "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "客户端类型",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.isAllPlatform ==
                                                              1
                                                              ? "全部端"
                                                              : "指定端"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          item.isAllPlatform == "0"
                                            ? _c(
                                                "el-form-item",
                                                { attrs: { label: "指定端" } },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.platformLabel
                                                              ? item.platformLabel
                                                              : "-"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "赠品类型" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.couponLabel
                                                          ? item.couponLabel
                                                          : "-"
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "触发资源位" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.resourceLabel
                                                          ? item.resourceLabel
                                                          : "-"
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "触发场景" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.triggerSceneLabel
                                                          ? item.triggerSceneLabel
                                                          : "-"
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "发放次数" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.provideAmountLabel
                                                          ? item.provideAmountLabel
                                                          : "-"
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: { label: "过期重复发放" },
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.duplicateProvideLabel
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "短信提醒" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.isSmsNoticeLabel
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          item.isSmsNotice == "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "短信模板ID",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.smsNoticeTemplateLabel
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "push提醒" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.isPushNoticeLabel
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          item.isPushNotice == "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "push模板ID",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.pushNoticeTemplateLabel
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "活动规则" + (index + 1),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.ruleTypeLabel) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-left": "50px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "用户类型" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.userTypeLabel)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          item.userType === "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "用户标签" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.userTagsLabel
                                                              ? item.userTagsLabel
                                                              : "-"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          item.userType === "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "用户数量" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.userAmountLabel
                                                              ? item.userAmountLabel
                                                              : "-"
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "触发条件" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.activeModeLabel)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          [1, 2].includes(+item.activeMode)
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "会员类别" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.vipTypeLabel
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          [1, 2].includes(+item.activeMode)
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "会员商品" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.productIdLabel
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          item.activeMode === "4"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "邀请人数" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.provideThresholdLabel
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "赠品类型" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.giftIdLabel)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "可赠送最大数量",
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.maxAmountLabel)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "单账号发放数量",
                                              },
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.userAmountLabel
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "短信提醒" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.isSmsNoticeLabel
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          item.isSmsNotice == "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "短信模板ID",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.smsNoticeTemplateLabel
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-form-item",
                                            { attrs: { label: "push提醒" } },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "activity-content",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        item.isPushNoticeLabel
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          item.isPushNotice == "1"
                                            ? _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "push模板ID",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "activity-content",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            item.pushNoticeTemplateLabel
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ]
                          )
                        }),
                        _c(
                          "el-form-item",
                          { attrs: { label: "审核意见", prop: "content" } },
                          [
                            _c("el-input", {
                              attrs: {
                                clearable: "",
                                type: "textarea",
                                rows: 2,
                                placeholder: "审核意见",
                              },
                              model: {
                                value: _vm.approveForm.content,
                                callback: function ($$v) {
                                  _vm.$set(_vm.approveForm, "content", $$v)
                                },
                                expression: "approveForm.content",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: _vm.formSize,
                        type: "success",
                        loading: _vm.approveLoading,
                      },
                      on: { click: _vm.handleApproved },
                    },
                    [_vm._v("审核通过")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: _vm.formSize,
                        type: "warning",
                        loading: _vm.approveLoading,
                      },
                      on: { click: _vm.handleRejectApprove },
                    },
                    [_vm._v("审核不通过")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: _vm.formSize },
                      on: { click: _vm.handleCancelApprove },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("approve-log-popups", {
            attrs: { logs: _vm.logs, visible: _vm.showLog },
            on: {
              "update:visible": function ($event) {
                _vm.showLog = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }